/* eslint-disable */

import { useRecoilState, useRecoilValue, useRecoilValueLoadable } from 'recoil'
import { useEffect, useState } from 'react'
import { Button } from '../../Components/ui/button'
import MFOrdersSkeleton from '../../Components/SkeletonLoaders/MFOrdersSkeleton'
import NoBond from '../../assets/images/nodata.svg'
import { useNavigate } from 'react-router-dom'
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '../../Components/ui/accordian'
import env from '../../env/env'
import { toCurrency } from '../../utils/CurrencyUtil'
import {
  addNumberSuffix,
  capitalizeWords,
  FinancialGoalsReversed,
  monthShortNames,
} from '../../utils/Util'
import { Card, CardContent, CardHeader, CardTitle } from '../../Components/ui/card'
import { MoreHorizontal } from 'lucide-react'

import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarTrigger,
} from '../../Components/ui/menubar'
import IconsSelector from '../../store/IconsStore'
import { Separator } from '../../Components/ui/separator'
import { post } from '../../http/restservice'
import { userDetailsState } from '../LoginState'
import { useModal } from '../../hooks/use-modal-store'
import { useErrorPopup } from '../../hooks/useErrorPopup'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../Components/ui/dialog'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../Components/ui/select'
import { MFSIPs } from '../../store/AdminStore'
import SIPsEmpty from '../../Components/EmptyState/SIPsEmpty'

const UserBasketSIPs = ({ clientCode }) => {
  const userSIPs = useRecoilValueLoadable(MFSIPs(clientCode))
  const parseSIPs = userSIPs?.state === 'hasValue' && JSON.parse(userSIPs?.contents?.data)
  const sips = parseSIPs?.data || []
  const [goals, setGoals] = useState(null)
  const iconsList = useRecoilValue(IconsSelector)
  const [openMenubar, setOpenMenubar] = useState(null)
  const { onOpen } = useModal()
  const [showSIPCancel, setShowSIPCancel] = useState(false)
  const [selectedReason, setSelectedReason] = useState('13')
  const [selectedSIP, setSelectedSIP] = useState(null)

  const cancellationReasons = [
    { code: '01', description: 'Non availability of Funds' },
    { code: '02', description: 'Scheme not performing' },
    { code: '03', description: 'Service issue' },
    { code: '04', description: 'Load Revised' },
    { code: '05', description: 'Wish to invest in other schemes' },
    { code: '06', description: 'Change in Fund Manager' },
    { code: '07', description: 'Goal Achieved' },
    { code: '08', description: 'Not comfortable with market volatility' },
    { code: '09', description: 'Will be restarting SIP after few months' },
    { code: '10', description: 'Modifications in bank/mandate/date etc' },
    { code: '11', description: 'I have decided to invest elsewhere' },
    { code: '12', description: 'This is not the right time to invest' },
    { code: '13', description: 'Others' },
  ]

  const handleCancel = () => {
    setShowSIPCancel(false)
    handleSIPCancel()
  }

  const handleSIPCancel = async () => {
    setOpenMenubar(null)
    try {
      const payload = {
        clientCode: clientCode,
        regNo: selectedSIP?.sipRegId,
        sipCancelReason: 13,
      }

      const response = await post(`${env.API_URL}adminservice/api/actionPlan/cancelXsip`, payload)

      if (response.isError) {
        onOpen('openAdminPopup', {
          title: 'SIP Cancellation',
          message: response?.response?.message,
          severity: 'info',
        })
      }

      if (
        response?.status === 'SUCCESS' &&
        response?.message?.includes('XSIP cancelled successfully')
      ) {
        onOpen('openAdminPopup', {
          title: 'SIP Cancelled',
          message:
            'Your SIP has been successfully cancelled. Please check your email for further details.',
          severity: 'success',
        })
      }

      console.log('🚀 ~ handlePauseSIP ~ response:', response)
    } catch (error) {
      console.error('Request failed:', error)
      return []
    }
  }

  useEffect(() => {
    if (userSIPs?.state === 'hasValue' && sips?.length > 0) {
      const groupedSIPs = sips?.reduce((acc, sip) => {
        if (sip.customerBasketInvestmentId) {
          acc[sip.customerBasketInvestmentId] = acc[sip.customerBasketInvestmentId] || []
          acc[sip.customerBasketInvestmentId].push(sip)
        }
        return acc
      }, {})

      setGoals(groupedSIPs)
    }
  }, [])

  const navigate = useNavigate()
  //   const refreshSIPs = useRecoilRefresher_UNSTABLE(MutualFundsSIPs)

  //   useEffect(() => refreshSIPs(), [])

  const calculateParcentage = (part, total) => {
    const result = (part / total) * 100
    return result ? result.toFixed(2) : 0
  }

  const getTotalAmount = (sips) => {
    const sipTotal = sips.reduce((acc, sip) => acc + Number(sip.installmentAmt), 0) || 0

    return sipTotal
  }

  const getDate = (dateString) => {
    if (!dateString) return null // Handle null/undefined cases

    // Determine the correct delimiter
    const delimiter = dateString.includes('/') ? '/' : '-'

    return dateString.split(delimiter)[0]
  }

  const getMonth = (dateString) => {
    if (!dateString) return null // Handle null/undefined cases

    // Determine the correct delimiter
    const delimiter = dateString.includes('/') ? '/' : '-'

    return dateString.split(delimiter)[1]
  }

  const getYear = (dateString) => {
    if (!dateString) return null // Handle null/undefined cases

    // Determine the correct delimiter
    const delimiter = dateString.includes('/') ? '/' : '-'

    return dateString.split(delimiter)[2]
  }

  const getSipsInfo = (sips = []) => {
    return sips
      ?.filter((sip) => sip.customerBasketInvestmentId !== null)
      ?.reduce(
        (acc, item) => {
          if (item.sipStatus === 'ACTIVE') {
            acc.totalAmount += Number(item.installmentAmt) || 0
            acc.totalSIPCount += 1
          }
          return acc
        },
        { totalAmount: 0, totalSIPCount: 0 },
      )
  }

  const getSipOverallStatus = (sips) => {
    const activeSipCount = sips?.reduce(
      (acc, sip) => (sip.sipStatus === 'ACTIVE' ? acc + 1 : acc),
      0,
    )

    if (activeSipCount === sips.length) {
      return 'Active'
    } else if (activeSipCount === 0) {
      return 'Cancelled'
    } else {
      return 'Partial'
    }
  }

  if (sips.length === 0) {
    return (
      <div className='bg-white flex items-center justify-center'>
        <SIPsEmpty
          title='No Basket SIPs Found'
          description='No basket SIPs found for this client code'
          mainText='No basket SIPs found'
          page='basket-SIPs'
          showButton={false}
        />
      </div>
    )
  }

  switch (userSIPs.state) {
    case 'loading':
      return (
        <div className='max-w-[1128px] mx-auto'>
          <MFOrdersSkeleton />
        </div>
      )

    case 'hasValue':
      return (
        <div className='bg-white min-h-screen'>
          <div className='mb-6 px-2'>
            <div className='w-full mt-4 lg:max-w-2xl mx-auto px-6 py-4 rounded-xl md:rounded-3xl border text-nowrap bg-[#F4F7FE]'>
              <div className='flex justify-between items-center space-x-6'>
                <div className='space-y-1 flex-1'>
                  <p className='font-semibold text-black-500 text-lg'>
                    {getSipsInfo(sips)?.totalSIPCount}
                  </p>

                  <p className='text-sm font-medium text-black-400'>No. of active SIPs</p>
                </div>
                <Separator orientation='vertical' className='h-11' />

                <div className='space-y-1 flex-1'>
                  <p className='font-semibold text-black-500 text-lg'>
                    ₹ {toCurrency(getSipsInfo(sips)?.totalAmount)}
                  </p>

                  <p className='text-sm font-medium text-black-400'>Active SIP amount</p>
                </div>
              </div>
            </div>
          </div>

          <div className='max-w-[1128px] px-4 lg:px-0 mx-auto'>
            <div className='hidden md:flex justify-between bg-[#F4F7FE] rounded-lg pl-14'>
              <div className='text-primary-400 text-sm font-medium py-3'>Goal Name</div>

              <div className='text-primary-400 text-sm font-medium py-3 px-4'>Amount</div>
            </div>
            {goals && Object.keys(goals).length > 0 && (
              <Accordion type='single' collapsible className='w-full'>
                {Object.entries(goals).map(([basketId, sips]) => (
                  <AccordionItem value={basketId} key={basketId}>
                    <AccordionTrigger className='hover:no-underline'>
                      <div className='flex justify-between items-center w-full'>
                        <div className='w-full'>
                          <div className='w-full flex md:justify-between items-start md:items-center gap-x-2'>
                            <img
                              src={
                                iconsList['light' + FinancialGoalsReversed[sips[0]?.planType]]
                                  ? iconsList['light' + FinancialGoalsReversed[sips[0]?.planType]]
                                  : `${env.SVGS}/basket.svg`
                              }
                              className='h-12 w-12 rounded-[8px] mt-1'
                            />
                            <div className='w-full'>
                              <div className='flex justify-between gap-x-4 items-center'>
                                <p className='font-semibold text-gray-900 text-wrap leading-6 flex items-center gap-x-2'>
                                  <span className='truncate whitespace-nowrap overflow-hidden max-w-[200px] md:max-w-max'>
                                    {' '}
                                    {sips[0]?.customerBasketName}
                                  </span>
                                  <span
                                    className={`text-sm ${
                                      getSipOverallStatus(sips) === 'Active'
                                        ? 'text-secondary-500 bg-secondary-50 rounded-full px-2'
                                        : getSipOverallStatus(sips) === 'Cancelled'
                                        ? 'text-error-500 bg-error-50 rounded-full px-2'
                                        : 'text-warning-500 bg-warning-50 rounded-full px-2'
                                    }`}
                                  >
                                    {getSipOverallStatus(sips)}
                                  </span>
                                </p>
                              </div>

                              <p className='text-sm text-black-400'>
                                Repeats on the{' '}
                                <strong>{addNumberSuffix(getDate(sips[0]?.sipStartDate))}</strong>{' '}
                                of every month
                              </p>

                              <div className='flex justify-between items-center'>
                                <div className='flex gap-x-1 text-xs items-center text-black-400'>
                                  Start Date -
                                  <p className='flex justify-start text-xs items-center gap-x-1 text-center font-DMSans'>
                                    <span className='font-semibold'>
                                      {getDate(sips[0]?.sipStartDate)}
                                    </span>
                                    <span className='font-semibold '>
                                      {monthShortNames[getMonth(sips[0]?.sipStartDate) - 1]}
                                    </span>
                                    <span className='font-semibold '>
                                      {getYear(sips[0]?.sipStartDate)}
                                    </span>
                                  </p>
                                </div>

                                <p className='text-nowrap pr-2 md:hidden'>
                                  ₹ {toCurrency(getTotalAmount(sips))}
                                </p>
                              </div>
                            </div>

                            <div className='hidden md:flex'>
                              <p className='text-nowrap pr-2'>
                                ₹ {toCurrency(getTotalAmount(sips))}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </AccordionTrigger>

                    <AccordionContent>
                      <div>
                        {sips?.map((sip, index) => {
                          return (
                            <div
                              className={`p-4 flex items-center lg:items-start w-full`}
                              key={index}
                            >
                              <div className='flex justify-between items-center w-full'>
                                <div className='flex justify-between items-center w-full'>
                                  <div className='w-full flex justify-between items-center gap-x-2'>
                                    <div className='flex gap-x-4 items-center md:w-[50%]'>
                                      <img
                                        src={`${env.MF_LOGOS_URL}/${sip?.amcCode}.png`}
                                        className='h-12 w-12 rounded-[8px] mt-1'
                                      />
                                      <div className='w-full md:w-auto'>
                                        <p className='font-semibold text-gray-900  md:max-w-full text-wrap leading-6'>
                                          {sip?.sname ? sip?.sname : sip?.amfiName}
                                          <span
                                            className={`text-sm ${
                                              capitalizeWords(sip?.sipStatus) === 'Active'
                                                ? 'text-secondary-500 bg-secondary-50 rounded-full px-2'
                                                : capitalizeWords(sip?.sipStatus) === 'Cancelled'
                                                ? 'text-error-500 bg-error-50 rounded-full px-2'
                                                : 'text-warning-500 bg-warning-50 rounded-full px-2'
                                            }`}
                                          >
                                            {capitalizeWords(sip?.sipStatus)}
                                          </span>{' '}
                                        </p>
                                      </div>
                                    </div>

                                    {sip?.installmentAmt && (
                                      <p className='text-nowrap text-sm font-medium text-black-400'>
                                        {calculateParcentage(
                                          sip.installmentAmt,
                                          getTotalAmount(sips),
                                        )}{' '}
                                        %
                                      </p>
                                    )}
                                  </div>
                                </div>
                                <div className='ml-4'>
                                  <Menubar className='border-0 bg-transparent p-0'>
                                    <MenubarMenu>
                                      <MenubarTrigger asChild>
                                        <Button
                                          variant='ghost'
                                          size='sm'
                                          className='h-6 w-6 p-0 rounded-full hover:bg-gray-100 cursor-pointer'
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            setOpenMenubar(openMenubar === sip.id ? null : sip.id)
                                          }}
                                        >
                                          <MoreHorizontal className='h-4 w-4' />
                                        </Button>
                                      </MenubarTrigger>
                                      <MenubarContent align='end' className='w-48'>
                                        <MenubarItem
                                          className='text-error-500 bg-error-50 cursor-pointer'
                                          onClick={() => {
                                            setShowSIPCancel(true), setSelectedSIP(sip)
                                          }}
                                        >
                                          Cancel SIP
                                        </MenubarItem>
                                      </MenubarContent>
                                    </MenubarMenu>
                                  </Menubar>
                                </div>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            )}
          </div>

          <Dialog open={showSIPCancel} onOpenChange={setShowSIPCancel}>
            <DialogContent className='sm:max-w-md'>
              <DialogHeader className='text-center space-y-4'>
                <DialogTitle className='text-xl text-center font-normal text-black-400'>
                  Your SIP of ₹ <strong>{toCurrency(selectedSIP?.installmentAmt)}</strong> will be
                  deleted
                </DialogTitle>
              </DialogHeader>

              <div className='space-y-6 pt-4'>
                <div className='space-y-3'>
                  <label className='text-base font-medium text-gray-900'>
                    Reason for cancellation
                  </label>
                  <Select value={selectedReason} onValueChange={setSelectedReason}>
                    <SelectTrigger className='w-full h-12 text-gray-500 border'>
                      <SelectValue placeholder='Select a reason' />
                    </SelectTrigger>
                    <SelectContent className='z-[10000]'>
                      {cancellationReasons.map((reason) => (
                        <SelectItem
                          key={reason.code}
                          value={reason.code}
                          className='py-3 cursor-pointer text-black-500 text-sm hover:bg-gray-50'
                        >
                          {reason.description}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>

                <div className='flex gap-3 pt-4'>
                  <Button
                    variant='outline'
                    className='flex-1'
                    onClick={() => setShowSIPCancel(false)}
                  >
                    Keep SIP
                  </Button>
                  <Button
                    className='flex-1 bg-primary-600'
                    onClick={handleCancel}
                    disabled={!selectedReason}
                  >
                    Cancel SIP
                  </Button>
                </div>
              </div>
            </DialogContent>
          </Dialog>
        </div>
      )

    case 'hasError':
      return (
        <div className='bg-white flex items-center justify-center'>
          <SIPsEmpty
            title='No Basket SIPs Found'
            description='No basket SIPs found for this client code'
            mainText='No basket SIPs found'
            page='basket-SIPs'
            showButton={false}
          />
        </div>
      )
  }
}
export default UserBasketSIPs
